/** @jsxImportSource @emotion/react */
import { Row, Col, Tag, Button } from "antd";
import React from "react";
import { Images } from "../../common/images";

export interface FilterItem {
  label: string;
  key: string;
  value: string;
}

interface LayoutContentFilterBarProps {
  onSettingClick?: () => void;
  onFilterClick: () => void;
  onFilterClose: (item: FilterItem) => void;
  filters: FilterItem[];
}

type LayoutContentFilterBarPropsType =
  React.PropsWithChildren<LayoutContentFilterBarProps>;

const LayoutContentFilterBarComponent: React.FC<LayoutContentFilterBarPropsType> =
  ({
    onSettingClick,
    onFilterClick,
    onFilterClose,
    filters,
  }: LayoutContentFilterBarPropsType) => {
    const onFilterClickHandle = React.useCallback(() => {
      onFilterClick();
    }, [onFilterClick]);

    const onSettingClickHandle = React.useCallback(() => {
      if (onSettingClick) {
        onSettingClick();
      }
    }, [onSettingClick]);

    const onTagCloseHandle = React.useCallback(
      (item) => () => {
        onFilterClose(item);
      },
      [onFilterClose],
    );

    return (
      <Row
        style={{ paddingBottom: "20px" }}
        align="middle"
        justify="space-between"
      >
        <Col xs={20}>
          {filters.map((item) => (
            <Tag closable key={item.key} onClose={onTagCloseHandle(item)}>
              {item.label}: {item.value}
            </Tag>
          ))}
        </Col>
        <Col xs={4}>
          <Row justify="end">
            <Button
              shape="circle"
              icon={<img src={Images.FILTER_DE} />}
              size="large"
              onClick={onFilterClickHandle}
            />
            {onSettingClick && (
              <Button
                shape="circle"
                icon={<img src={Images.SETTING_DE} />}
                size="large"
                onClick={onSettingClickHandle}
                style={{ marginLeft: "16px" }}
              />
            )}
          </Row>
        </Col>
      </Row>
    );
  };

export const LayoutContentFilterBar = React.memo(
  LayoutContentFilterBarComponent,
);
